// The set of AndHub apps the screen watermark can be scoped to. Each app maps a set
// of route prefixes to an id, so the renderer can decide whether the current page
// belongs to a selected app. Keep in sync with the routes in App.tsx.

export interface WatermarkApp {
  id: string;
  label: string;
  match: (pathname: string) => boolean;
}

export const WATERMARK_APPS: WatermarkApp[] = [
  { id: 'home',     label: 'Home / Launcher', match: (p) => p === '/home' || p === '/platforms' },
  { id: 'andone',   label: 'AndOne',          match: (p) => p.startsWith('/andone') },
  { id: 'andtimes', label: 'AndTimes',        match: (p) => p.startsWith('/andtimes') },
  { id: 'andplay',  label: 'AndPlay',         match: (p) => p.startsWith('/andplay') },
  { id: 'anddocs',  label: 'AndDocs',         match: (p) => p.startsWith('/anddocs') },
  { id: 'projects', label: 'Projects',        match: (p) => p.startsWith('/projects') },
];

/** The app id a route belongs to, or null if it maps to no listed app. */
export function appIdForPath(pathname: string): string | null {
  return WATERMARK_APPS.find((a) => a.match(pathname))?.id ?? null;
}
